import { createContext, useRef, useContext } from 'react'
import { useStore } from 'zustand'
import { CompProps } from 'types'
import { createGoalHabitsStore } from './store'
import {
  GoalHabitsCtxType,
  GoalHabitsInitialState,
  GoalHabitsStore,
} from './types'

type CTX = GoalHabitsCtxType

export const GoalHabitsContext = createContext({} as CTX)

export const GoalHabitsProvider = ({
  children,
  ...props
}: CompProps<GoalHabitsInitialState>) => {
  const storeRef = useRef<CTX>()

  if (!storeRef.current) {
    storeRef.current = createGoalHabitsStore({ ...props })
  }

  return (
    <GoalHabitsContext.Provider value={storeRef.current}>
      {children}
    </GoalHabitsContext.Provider>
  )
}

export function useGoalHabits<T>(selector: (store: GoalHabitsStore) => T): T {
  const ctx = useContext(GoalHabitsContext)

  if (ctx === undefined) {
    throw new Error(
      'GoalHabits selector must be used within GoalHabitsProvider'
    )
  }

  return useStore(ctx, selector)
}
